import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "filter-block" }
const _hoisted_3 = ["placeholder"]

import { useStore } from 'vuex'
import { ref, computed, onMounted } from 'vue'

import { EPINIO_TYPES } from '../types'

import Loading from '@shell/components/Loading.vue'
import SelectIconGrid from '@shell/components/SelectIconGrid.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'catalogservices',
  props: {
    schema: {}
  },
  setup(__props: any) {

const store = useStore()
const props = __props; // eslint-disable-line @typescript-eslint/no-unused-vars

const pending = ref(true);
const searchQuery = ref(null);

onMounted(async () => {
  await store.dispatch(`epinio/findAll`, { type: EPINIO_TYPES.CATALOG_SERVICE });
  pending.value = false;
})

const list = computed(() => {
  const catalogList = store.getters['epinio/all'](EPINIO_TYPES.CATALOG_SERVICE)
  
  if (!searchQuery.value) {
    return catalogList;
  } else {
    const query = searchQuery.value.toLowerCase();

    return catalogList.filter((e) => e?.chart.toLowerCase().includes(query) || 
      e?.description.toLowerCase().includes(query) || 
      e?.short_description.toLowerCase().includes(query));
  }
})

const showDetails = (chart: any) => {
  store.$router.push(chart.detailLocation)
}

const colorFor = () => {
  return `color-1`
}

return (_ctx: any,_cache: any) => {
  return (pending.value)
    ? (_openBlock(), _createBlock(Loading, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
            type: "search",
            class: "input-sm",
            placeholder: _ctx.t('catalog.charts.search')
          }, null, 8, _hoisted_3), [
            [_vModelText, searchQuery.value]
          ])
        ]),
        _cache[2] || (_cache[2] = _createTextVNode()),
        _createVNode(SelectIconGrid, {
          rows: list.value,
          "color-for": colorFor,
          "name-field": "name",
          "icon-field": "serviceIcon",
          "key-field": "name",
          "description-field": "short_description",
          onClicked: _cache[1] || (_cache[1] = (row) => showDetails(row))
        }, null, 8, ["rows"])
      ]))
}
}

})